import axios from 'axios';
const BASE_URL = 'https://api.swgrlynx.com';


function getDeviceData(deviceID = "") {
    let token = 'Bearer ' + localStorage.getItem('id_token');
    const url = `${BASE_URL}/api/devInformationData?dev=${deviceID}`;
    return axios.get(url,{ headers: { Authorization: token } })
        .then(response => [response.data.iotData.state.reported.iodb,response.data.iotData.state.reported.deviceInfo])
        .catch((error) => {

        });
}


function getUserInformation() {
    let token = 'Bearer ' + localStorage.getItem('id_token');
    const url = `${BASE_URL}/api/user/profileData`;
    return axios.get(url,{ headers: { Authorization: token } })
        .then(response => response.data
        )
        .catch((error) => {

            }
        );
}

function getSystemUserInformation() {
    let token = 'Bearer ' + localStorage.getItem('id_token');
    const url = `${BASE_URL}/api/user/getUserSidebar`;
    return axios.get(url,{ headers: { Authorization: token } })
        .then(response => response.data
        )
        .catch((error) => {

            }
        );
}

function ajaxWrapperGet(requestURL, deviceID = "") {
    let token = 'Bearer ' + localStorage.getItem('id_token');
    //const url = `${BASE_URL}${requestURL}?dev=${deviceID}`;
    const url = `${BASE_URL}${requestURL}${deviceID === "" ? "" : "?dev=" + deviceID}`;
    return axios.get(url,{ headers: { Authorization: token } })
        .then(response => response.data)
        .catch((error) => {

        });
}

function ajaxWrapperGetQuery(requestURL,deviceID,query) {
    let token = 'Bearer ' + localStorage.getItem('id_token');
    const url = `${BASE_URL}${requestURL}?dev=${deviceID}${query}`;
    return axios.get(url,{ headers: { Authorization: token } })
        .then(response => response.data)
        .catch((error) => {

        });
}


function ajaxWrapperPost(requestURL,data) {
    let token = 'Bearer ' + localStorage.getItem('id_token');
    const url = `${BASE_URL}${requestURL}`;
    return axios.post(url,data,{
        headers: { Authorization: token },
    })
        .then(response => response.data)
        .catch((error) => {

        });
}

function ajaxWrapperDelete(requestURL) {
    let token = 'Bearer ' + localStorage.getItem('id_token');
    const url = `${BASE_URL}${requestURL}`;
    return axios.delete(url,{
        headers: { Authorization: token}
    })
        .then(response => response.data)
        .catch((error) => {

        });
}

function getAdminUsers() {
    let token = 'Bearer ' + localStorage.getItem('id_token');
    const url = `${BASE_URL}/api/admin/users`;
    return axios.get(url,{ headers: { Authorization: token } })
        .then(response => response.data
        )
        .catch((error) => {

            }
        );
}

export {getDeviceData, getUserInformation, ajaxWrapperGet, getAdminUsers, ajaxWrapperPost, ajaxWrapperDelete, ajaxWrapperGetQuery, getSystemUserInformation};


// WEBPACK FOOTER //
// ./src/utils/deviceAPI.js